module.exports = __webpack_public_path__ + "img/icon_cost.bda81836.svg";